import $ from "jquery";
import i18n from "@I18n/services/i18n";
import messages from "./messages";

$(document).ready(() => {
  let user_id = (window as any).user_id;

  $("#edit_user_" + user_id).on("click", "#edit_password_submit", function () {
    let user_password = document.getElementById("user_password");
    let user_password_confirmation = document.getElementById(
      "user_password_confirmation"
    );
    const editPassword = document.querySelector("#edit_password_feedbacks");

    if ((user_password as HTMLInputElement).value.length < 6) {
      if (editPassword) {
        (editPassword as HTMLElement).style.display = "block";
      }

      $("#edit_password_feedbacks").html(
        i18n.formatMessage(messages.passwordMinLength)
      );
      return false;
    } else if (
      (user_password as HTMLInputElement).value !=
      (user_password_confirmation as HTMLInputElement).value
    ) {
      if (editPassword) {
        (editPassword as HTMLElement).style.display = "block";
      }

      $("#edit_password_feedbacks").html(
        i18n.formatMessage(messages.passwordSame)
      );
      return false;
    } else {
      if (editPassword) {
        (editPassword as HTMLElement).style.display = "none";
      }

      return true;
    }
  });
});
